import { Component, ViewChild, TemplateRef, Output, EventEmitter, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss']
})
export class DeleteModalComponent {

  public closeResult: string | undefined;
  public modalOpen: boolean = false;
  public userAction = {};
  public title: string;
  public message: string;
  @Input() windowClass: string = '';
  @Input() confirmText: string = '';
  @Input() cancelText: string = '';

  @ViewChild("deleteModal", { static: false }) DeleteModal: TemplateRef<string> | undefined;

  @Output() deleteItem: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: NgbModal) { }

  async openModal(action: string, data: any, title: string = '', message: string = '') {
    this.title = title;
    this.message = message;
    this.modalOpen = true;
    this.userAction = {
      actionToPerform: action,
      data: data
    };
    this.modalService.open(this.DeleteModal, {
      ariaLabelledBy: 'Delete-Modal',
      centered: true,
      windowClass: `theme-modal text-center ${this.windowClass}`.trim()
    }).result.then((result) => {
      `Result ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  delete(modal: NgbModalRef) {
    this.deleteItem.emit(this.userAction);
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }

}
